
export default () => {

    document.querySelectorAll('.in-up').forEach(el => {

        gsap.to(el, {
            scrollTrigger:
            {
                trigger: el,
                // markers: true,
                start: 'top 80%'
            },
            opacity: 1,
            y: 0
        })
    })

    document.querySelectorAll('.stagger-in-up').forEach(el => {
        gsap.to(el.children, {
            scrollTrigger:
            {
                trigger: el,
                // markers: true,
                start: 'top 80%'
            },
            opacity: 1,
            y: 0,
            stagger: 0.1
        })
    })
}
